export default __webpack_public_path__ + "static/media/retreiveOnePIC1.74f12c40.jfif";